import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col,Table } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
import Button from "react-bootstrap/Button";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";
import React,{useEffect,useState} from "react";
import { Scrollbars } from "react-custom-scrollbars";
import ProgressBar from "@ramonak/react-progress-bar";
import  '../CSS/styles.scss'
import TableScrollbar from 'react-table-scrollbar';

// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";
import ApplicationDetails2Db from '../database/ApplicationDetails2Db.json'
import VisaDetailsDb from '../database/VisaDetailsDb.json';
import LeadVolume from '../database/LeadVolume.json';
 import LeadsByMonth from '../database/LeadsByMonth.json';
 import YearToDateVisual from '../database/Year-To-Date-Visual.json';
import RadialBarChart from "../Grpahs/RadialBarChart";
import StudentDropoutsByBranch from '../database/StudentDropoutsByBranch.json'
import Treemap from "../Grpahs/Treemap";
import StudentDropoutsByMonth from '../database/StudentDropoutsByMonth.json'
import Header from "./Header";

 const VisaDetails= () => {

    const [ttl, setttl]=useState(0);
  const [perTa, setPerTa]=useState(0);
  const [tUniqueA, setTUniqueA]=useState(0);
  const [perTUniqueA, setPerTUniqueA]=useState(0);
  const [applicPerStu, setApplicPerStu]= useState(0);
  const [visaD, setVisaD]= useState(0);
  const [perVisaD, setPerVisaD]= useState(0);
 


  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1
  };


  useEffect(()=>{
    userAdd();
    userPerAdd();
    totalUniqueAppli();
    perTotalUniqueAppli();
    totalUniqueAppli();
    appliPerStudent();
    visaRejected()
    perVisaRejected()
  },[])
  



  function userAdd(){
    const rec = VisaDetailsDb
    var sum=0;
      for(var i=0; i<rec.length; i++){
        sum += parseInt(rec[i].tVF)
      }
      setttl(sum)
    }

    function userPerAdd(){
      const rec = VisaDetailsDb
      var sum=0;
        for(var i=0; i<rec.length; i++){
          sum += parseInt(rec[i].vGrant)
        }
        setPerTa(sum)
      }

      function totalUniqueAppli(){
        const rec = VisaDetailsDb
        var sum=0;
          for(var i=0; i<rec.length; i++){
            sum += parseInt(rec[i].perVGrant)
          }
          setTUniqueA(sum)
        }

        function perTotalUniqueAppli(){
          const rec = VisaDetailsDb
          var sum=0;
            for(var i=0; i<rec.length; i++){
              sum += parseInt(rec[i].vIProcess)
            }
            setPerTUniqueA(sum)
          }

          function appliPerStudent(){
            const rec = VisaDetailsDb
            var sum=0;
              for(var i=0; i<rec.length; i++){
                sum += parseInt(rec[i].perVIProcess)
              }
              setApplicPerStu(sum)
            }

            function visaRejected(){
                const rec = VisaDetailsDb
                var sum=0;
                  for(var i=0; i<rec.length; i++){
                    sum += parseInt(rec[i].vRejected)
                  }
                  setVisaD(sum)
                }


                function perVisaRejected(){
                    const rec = VisaDetailsDb
                    var sum=0;
                      for(var i=0; i<rec.length; i++){
                        sum += parseInt(rec[i].perVRejected)
                      }
                      setPerVisaD(sum)
                    }


  return (
    <React.Fragment>
    <Header/>
      <Container fluid style={{height:'80%'}}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "50px" }}>
                    <strong>&nbsp;Visa Details</strong>
                  </h2>
                </Col>
                
                <Col
                  xs={3}
                  
                  
                >
                  <Card
                    className="text-center"
                    style={{
                      
                      boxShadow: "2px 2px 8px ",
                      
                       height: "100px",
                       width: "210px",
                       marginTop: '3px',
                       marginLeft: "52px",
                       position:'initial'
                  
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      Total Leads Generated
                    </Card.Header>
                    <Card.Body
                      style={{ paddingTop: "6px", textAlign: "center" }}
                    >
                      <h1>17</h1>
                    </Card.Body>
                  </Card>
                  </Col>
                  
                  <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      height: "100px",
                      width: "210px",
                      boxShadow: "2px 2px 8px ",
                      marginTop:'3px',
                      // position:'initial'
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black" }}
                    >
                      Date Range
                    </Card.Header>
                    <Card.Body style={{ paddingTop: "1px" }}>
                      
                  <DateRangeComp/>




                    </Card.Body>
                    </Card>
                  </Col>
                
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
                position:'initial'
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ",position:'initial' }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Month
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ",position:'initial' }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Branch
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position:'initial'
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select User
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ", width: "18rem",position:'initial' }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Year
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                
                <Slider {...settings} className='slider' style={{margin:'1px'}}>
                    <div>
                      <Button variant="secondary">2017</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2018</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2019</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2020</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2021</Button>
                    </div>
                    <div>
                      <Button variant="secondary">2022</Button>
                    </div>
                    
                      
                    
                  </Slider>
                
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row style={{marginTop:'5px'}}>
        <Col>
        <Card style={{height:'150px', boxShadow: "2px 2px 8px ",position:'initial'}}>
        <Card.Title style={{textAlign:'center',textDecoration:'underline'}}>Total Visa Filled By Details</Card.Title>
        <Card.Body>
        <label for="html">Total</label>
        <input type="radio" id="html" name="fav_language" value="HTML" />
             <label for="html" style={{paddingLeft:'15px'}}>376</label>
        
        </Card.Body>
        </Card>
        </Col>
        </Row>
        <Row style={{marginTop:'5px'}}>
          <Col>  
          <Card style={{boxShadow: "2px 2px 8px ",height:'255px',position:'initial'}}>
          
          
          <Card.Body style={{padding:'5px'}}>
          <div style={{height: "30vh"}}>
          <TableScrollbar rows={8}>
          
          
          <Table responsive="sm">
          
          <thead className="tableHeader">
            <tr>
            <th>
            Destination
            </th>
            <th>Total Visa Filled</th>
            <th>Visa Granted</th>
            <th>% of Visa  Granted</th>
            <th>Visa Inprocess</th>
            <th>% of Visa Inprocess</th>
            <th>Visa Rejected</th>
            <th>% of Visa Rejected</th>
            
            </tr>
          </thead>
         
          
          <tbody >
          
          
         
          
          {
            VisaDetailsDb.map((user=>(
            
             

 
               <tr>

              <td>{user.desti}</td>
              <td >
              
              <ProgressBar 
              completed={user.tVF}
              customLabel={user.tVF}
              
              maxCompleted={5}
              // bgColor='#eb8a5f'
              backgroundColor= '["red", "blue", "green", "blue", "red", "blue"]'
              baseBgColor='none'
              className="wrapper"
              barContainerClassName="container"
              completedClassName="barCompleted"
              labelClassName="label"
              

               />
              
              
              
              </td>
              
              <td className="percentae" >{user.vGrant}%</td>
              <td className="percentge">
              
              {user.perVGrant}
              
              </td>
              <td className="percenage">{user.vIProcess}%</td>
              <td className="percetage">
              

              {user.perVIProcess}


              </td> 
              <td>{user.vRejected}</td>
              <td>{user.perVRejected}</td>
               </tr>


              
             )))

             
           }
           
           
          
          <tr style={{position:'sticky',boxShadow: "1px -4px 18px 0px orangered", backgroundColor:'#5560ee', color:'white'}}>
          <td><strong>Total:</strong></td>
          <td><strong>{ttl}</strong>
          </td>
          <td><strong>{perTa}%</strong></td>
          <td><strong>{tUniqueA}</strong></td>
          <td><strong>{perTUniqueA}%</strong></td>
          <td><strong>{parseFloat(applicPerStu).toFixed(2)}</strong></td>
          <td><strong>{visaD}</strong></td>
          <td><strong>{perVisaD}%</strong></td>
          </tr>
          
          
           
           
           

           
           
           
           
           
          
          
          </tbody>
          
          
          
          
          
          
          
          </Table>
          </TableScrollbar>
          
          
           </div>
           
           

        


          
          


          </Card.Body>
          
          
          </Card>

          
          </Col>
        </Row>
        </Container>
        </React.Fragment>
  )
            }

            export default VisaDetails;
